import config from '../../config';

import modalTemplateUsersConflictUrl from './modal-template-users-conflict.html';

export default class ScheduleTemplateCtrl {
  ignoreConflicts = true;
  loading = true;

  constructor(
    Authentication,
    AlertService,
    ConfirmService,
    EventCollection,
    PersonaCollection,
    ShiftUtils,
    SidebarFiltersService,
    Utils,
    $uibModal,
    $uibModalInstance,
    /* resolves */ mode,
    date
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AlertService,
      ConfirmService,
      EventCollection,
      PersonaCollection,
      ShiftUtils,
      SidebarFiltersService,
      Utils,
      $uibModal,
      $uibModalInstance,
      mode,
      date,
    });
    this.init();
  }

  async init() {
    try {
      const { data } = await this.Authentication.sendRequest({
        path: 'shifts/templates',
        params: { type: this.mode },
      });
      this.templates = data;
      this.templates.forEach((template) => {
        template.date = new Date(template.created);

        const locationNames = template.locations
          .map((loc) => this.PersonaCollection.personasDict[loc.id]?.name)
          .filter(Boolean)
          .sort();
        if (locationNames.length <= 3) {
          template.locationsDescription = this.Utils.addJoin(locationNames);
        } else {
          template.locationsDescription = `${this.Utils.addJoin(locationNames.slice(0, 2))} and ${
            locationNames.length - 2
          } more...`;
        }
      });

      if (this.templates.length) {
        this.selectedTemplate = this.templates[0];
      }
    } finally {
      this.loading = false;
    }
  }

  async load() {
    if (!this.selectedTemplate) {
      throw 'no template selected';
    }

    let ignoredConflicts;
    let chosenInvalidUsers;

    const send = (ignoreConflicts, invalidUsers) => {
      /**
       * If both types of conflicts occur - scheduling and invalid users (deleted or deactivated)
       * this method will be executed each time a conflict modal is accepted.
       * We need to memoize previous answers otherwise we'd end up with an infinite
       * loop of conflict modals
       */
      ignoredConflicts = ignoredConflicts ?? ignoreConflicts;
      chosenInvalidUsers = chosenInvalidUsers ?? invalidUsers;
      return this.Authentication.sendRequest({
        method: 'post',
        path: `shifts/templates/${this.selectedTemplate.id}/load`,
        params: {
          type: this.mode,
          date: this.date,
          ignoreConflicts: ignoredConflicts || this.ignoreConflicts || ignoreConflicts,
          ignoreAssignees: this.ignoreAssignees,
          invalidUsersAction: chosenInvalidUsers || invalidUsers,
          checkRestBreakConflicts: config.CLOPENING_CONFLICT_ENABLED,
          checkConsecutiveWorkDaysConflicts: config.CONSECUTIVE_WORK_DAYS_LIMIT_ENABLED,
        },
      });
    };

    const { data: newShifts } = await this.ShiftUtils.performConflictingRequest({
      request: send,
      ignoreSuffix: 'load this template anyway',
      customConflicts: [
        {
          invalidUsersIds: async () =>
            await this.$uibModal.open({
              templateUrl: modalTemplateUsersConflictUrl,
              controllerAs: 'ctrl',
              size: '620',
            }).result,
        },
      ],
    });

    this.AlertService.success('Template has been successfully applied');
    this.EventCollection.addOrEditEvents(newShifts);
    this.EventCollection.undoingPossible = true;

    if (!this.SidebarFiltersService.optionsFilterState.showPlanningEvents) {
      this.SidebarFiltersService.optionsFilterState.showPlanningEvents = true;
      this.SidebarFiltersService.optionChanged('showPlanningEvents');
    }

    this.$uibModalInstance.close();
  }

  async deleteTemplate(template) {
    await this.ConfirmService.ask('Are you sure you want to delete this schedule template?');
    await this.Authentication.sendRequest({
      method: 'delete',
      path: `shifts/templates/${template.id}`,
    });
    this.templates = this.templates.filter((t) => t !== template);
    this.AlertService.success('Template deleted');
  }
}
